import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance30 = () => {
  return <IndividualTable matchType={"8"} gender="F" event="30" subTitle="Zamby" data={sampleData2} topRankCount="4" winners={["327", "318", "459", "330"]} />;
};
export default Distance30;
